const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('../pages/Home.vue')
  },
  {
    path: '/demo2',
    name: 'Demo2',
    component: () => import('../pages/Demo2')
  },
  {
    path: '/List',
    name: 'List',
    component: () => import('../components/main-components/main-tab.vue')
  },
  {
    path: '/onlineChart',
    name: 'onlineChart',
    component: () => import('../components/onlineChart/onlineChart.vue')
  },
  {
    path: '/trendJournalShow',
    name: 'trendJournalShow',
    component: () => import('../components/trendJournal/trendJournalShow.vue')
  },
  {
    path: '/onlineChartTrend',
    name: 'onlineChartTrend',
    component: () => import('../components/left-side/onlineChartTrendShow')
  },
  {
    path: '/graphiCallyShow',
    name: 'graphiCallyShow',
    component: () => import('../components/graphically/graphiCallyShow.vue')
  },
  {
    path: '/modelAdministrate',
    name: 'modelAdministrate',
    component: () => import('../components/graphically/modelAdministrate.vue')
  },
  {
    path: '/orderSelectAll',
    name: 'orderSelectAll',
    component: () => import('../components/orderSelect/orderSelect.vue')
  },
  {
    path: '/orderDetailsAll',
    name: 'orderDetailsAll',
    component: () => import('../components/orderSelect/orderDetails.vue')
  },
  {
    path: '/sceneCreation',
    name: 'sceneCreation',
    component: () => import('../components/orderSelect/SceneCreation.vue')
  },
  {
    path: '/onlineChartTraffic',
    name: 'onlineChartTraffic',
    component: () => import('../components/left-side/onlineChartTraffic.vue')
  },
  {
    path: '/productIntroduction',
    name: 'productIntroduction',
    component: () => import('../components/other/productIntroduction.vue')
  },
  {
    path: '/tencentView',
    name: 'tencentView',
    component: () => import('../components/graphically/tencentShow.vue')
  },
  {
    path: '/energyBarShow',
    name: 'energyBarShow',
    component: () => import('../components/timeChart/energyBarShow.vue')
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/demo.js